export default __webpack_public_path__ + "static/media/4.66d05295.webp";